import React from 'react';

export const ENV_RENDER_DESINGER = 'designer';

/**
 * getType
 * @param {*} variable
 * @returns
 */
export function getType (variable) {
  return Object.prototype.toString.call(variable).slice(8, -1).toLocaleLowerCase();
}

/**
 * getType
 * @param {*} variable
 * @returns
 */
export function isType (variable, type) {
  return getType(variable) === type;
}

/**
 * exportMdf6
 * @param {*} module
 * 注释：组件导出，key值小写
 */
export function exportMdf6 (module = {}) {
  if (typeof window !== "undefined" && window.$define) {
    if (isType(module, 'object')) {
      const exportMoudle = {};
      for (const x in module) {
        exportMoudle[x.toLocaleLowerCase()] = module[x];
      }
      window.$define([], function () {
        return exportMoudle;
      });
    }
  }
}

/**
 * 组件入口Wrapper
 * @param {*} Runtime
 * @param {*} Designer
 * @returns
 */
export const WrapperHoc = (Runtime, Designer) => {
  return function Wrapper (props) {
    // 渲染设计态组件
    if (Designer) {
      if (/designer$/.test(props?.ctx?.env?.renderEnv || '')) {
        return <Designer { ...props }></Designer>
      }
    }
    // 渲染运行态组件
    if (Runtime) {
      return <Runtime { ...props }></Runtime>
    }
  }
}

// 加载文件服务js
export const loadJS = (src, id, callback, flag = () => true) => {
  const exist = document.querySelector(`#${id}`);
  if (exist && flag?.()) {
    callback?.();
    return;
  }
  // 动态创建script标签，并挂到body上
  const body = document.querySelector("body");
  const script = document.createElement("script");
  script.id = id;
  script.src = src;
  body?.appendChild(script);
  // 第一个加载完毕后
  script.onload = () => {
    const timer = setInterval(() => {
      // 条件判断成功后才可以执行回调
      if (flag?.()) {
        clearInterval(timer);
        callback?.();
      }
    }, 100);
  };
};

export const getFileUrl = () => {
  const url = '/iuap-apcom-file/ucf-wh/fileservice/web/fileservice-web.min.js'
  if (url.startsWith('http')) {
    return url
  } else {
    return window.location + url
  }
}
